var exports = {
  "pq": "xaf9ae18d--a05999--info",
  "Me": "xaf9ae18d--a05999--info__group",
  "q$": "xaf9ae18d--a05999--info__group--title",
  "nX": "xaf9ae18d--a05999--info__group--time",
  "Kk": "xaf9ae18d--a05999--icon",
  "NW": "xaf9ae18d--a05999--type",
};

module.exports = exports;
